import { AutoComplete, PagedResponse } from '@elotech/components';
import { AxiosPromise } from 'axios';
import { Label } from 'common/components';
import { UNCPessoa } from 'common/type';
import React from 'react';

export type PessoaMatriculaSearchProps = {
  name: string;
  label?: string;
  value: UNCPessoa;
  error?: any;
  className?: string;
  visible?: boolean;
  onSelect: (name: string, value: UNCPessoa) => void;
  onSearch: (search: string) => AxiosPromise<PagedResponse<UNCPessoa>>;
};

const PessoaMatriculaSearch = ({
  name,
  value,
  error,
  onSelect,
  onSearch,
  label = 'Matrícula',
  className = 'form-group',
  visible = true
}: PessoaMatriculaSearchProps) => {
  if (!visible) {
    return null;
  }
  return (
    <div className={className}>
      <Label>{label}</Label>

      <AutoComplete<UNCPessoa>
        name={name}
        value={value}
        autoFocus={false}
        onSearch={onSearch}
        onSelect={onSelect}
        getOptionLabel={pessoa => `${pessoa.matricula}`}
        className={!!error ? 'error' : ''}
        getOptionValue={pessoa => pessoa.id}
      />

      {!!error && <span className="help-message">{error}</span>}
    </div>
  );
};

export { PessoaMatriculaSearch };
